import React from "react";
import { Field } from "formik";
import cn from "classnames";

const FormCheckbox = ({
  title,
  error = false,
  className = "styled-checkbox",
  name,
  value,
  id = "styled-checkbox-1",
}) => {
  return (
    <>
      <Field
        id={id}
        name={name}
        type="checkbox"
        className={cn(className, { error: error })}
        value={value}
      />
      <label htmlFor={id}>{title}</label>
    </>
  );
};

export default FormCheckbox;
